import { Children, ReactNode } from "react";

export type CpSwitchProps = {
  expression: string | number;
  children: ReactNode;
};

export type CpCaseProps =
  | { default: true; children: ReactNode; value?: never }
  | { value: string | number; children: ReactNode; default?: false };

export function CpSwitch({ expression, children }: CpSwitchProps) {
  const _children = Children.toArray(children);
  let defaultChild: React.ReactElement<CpCaseProps> | null = null;
  let result: React.ReactElement<CpCaseProps> | null = null;

  for (let i = 0; i < _children.length; i++) {
    const child = _children[i] as React.ReactElement<CpCaseProps>;
    if (!child?.props) continue;

    const value = child?.props?.value;
    const _default = !!child?.props?.default;
    const values = Array.isArray(value) ? value : [value];
    const match = values.some((v) => v === expression);

    if (_default) {
      if (defaultChild) {
        throw Error(`[CpSwitch] Only one default case allowed.`);
      }
      defaultChild = child;
    }

    if (match) {
      result = child;
      break;
    }
  }

  if (!result && defaultChild) {
    result = defaultChild;
  }

  return result;
}

export function CpCase({ children }: CpCaseProps) {
  return children;
}
